/**
 * Admin Protected Route
 *
 * Guards admin pages: requires authentication AND is_platform_admin flag.
 * Non-admins are silently redirected to the org dashboard.
 */

import { Navigate } from 'react-router-dom'
import { useAuth } from '@/features/auth/context/AuthContext'

export function AdminProtectedRoute({ children }: { children: React.ReactNode }) {
  const { user, isAuthenticated, loading } = useAuth()

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
      </div>
    )
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  if (!user?.is_platform_admin) {
    return <Navigate to="/" replace />
  }

  return <>{children}</>
}
